import { Card, List, ListItem, Paragraph } from "@george-labs.com/design-system"
import { RealEstateOwnerDTO } from "@smartx/mikro-vt-client-api"
import { useTranslation } from "react-i18next"

interface OverviewRealEstateOwnersProps {
  realEstateOwners: RealEstateOwnerDTO[]
}

const OverviewRealEstateOwners: React.FC<OverviewRealEstateOwnersProps> = ({
  realEstateOwners,
}) => {
  const { t } = useTranslation()

  return (
    <Card>
      <h3>{t("case.fields.realEstateOwners")}</h3>
      {realEstateOwners?.length === 0 && (
        <Paragraph className="text-center g-fg-ui-yellow p-3">
          {t("case.overview.warnings.noRealEstateOwners")}
        </Paragraph>
      )}

      <List>
        {realEstateOwners?.length > 0 &&
          realEstateOwners?.map((owner: RealEstateOwnerDTO, idx: number) => {
            return <ListItem key={"owner-" + idx}>{owner.name}</ListItem>
          })}
      </List>
    </Card>
  )
}

export default OverviewRealEstateOwners
